import { mapDTO } from '@twistezo/ts-dto-mapper'

import { RichPlacementMultianchor } from '../types'
import { RichPlacementMultianchorDTO } from './types'

type From = RichPlacementMultianchorDTO
type To = RichPlacementMultianchor

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({
      customStyling,
      displayAfterUserInteractionEnabled,
      fullWidthModeEnabled,
      showCloseButtonEnabled,
      singleAdViewTime,
    }: From): To => ({
      customStyling: customStyling ?? '',
      displayAfterUserInteraction: displayAfterUserInteractionEnabled,
      fullWidthMode: fullWidthModeEnabled,
      showCloseButton: showCloseButtonEnabled,
      singleAdViewTime,
    }),
  )
